"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _OptionsDropdown = _interopRequireDefault(require("../OptionsDropdown"));

var _styled = require("./styled");

var _reactHooks = require("@trycourier/react-hooks");

var _lib = require("../../lib");

var _hooks = require("../../hooks");

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Message = function Message(_ref) {
  var _brand$inapp, _ref3, _brand$inapp2, _brand$inapp2$icons;

  var blocks = _ref.blocks,
      body = _ref.body,
      created = _ref.created,
      data = _ref.data,
      defaultIcon = _ref.defaultIcon,
      formatDate = _ref.formatDate,
      icon = _ref.icon,
      labels = _ref.labels,
      messageId = _ref.messageId,
      opened = _ref.opened,
      openLinksInNewTab = _ref.openLinksInNewTab,
      read = _ref.read,
      renderBlocks = _ref.renderBlocks,
      title = _ref.title,
      _ref$trackingIds = _ref.trackingIds,
      trackingIds = _ref$trackingIds === void 0 ? {} : _ref$trackingIds;
  var ref = (0, _react.useRef)(null);

  var _ref2 = trackingIds || {},
      readTrackingId = _ref2.readTrackingId,
      unreadTrackingId = _ref2.unreadTrackingId,
      openTrackingId = _ref2.openTrackingId;

  var _useInbox = (0, _reactHooks.useInbox)(),
      brand = _useInbox.brand,
      markMessageRead = _useInbox.markMessageRead,
      markMessageOpened = _useInbox.markMessageOpened;

  var renderedIcon = (0, _styled.getIcon)(
  /* priority:
    1. from message
    2. from props.defaultIcon
    3. from props.brand.inapp.icons.message
    4. from remote brand.inapp.icons.message
  */
  brand !== null && brand !== void 0 && (_brand$inapp = brand.inapp) !== null && _brand$inapp !== void 0 && _brand$inapp.disableMessageIcon ? false : (_ref3 = icon || defaultIcon) !== null && _ref3 !== void 0 ? _ref3 : brand === null || brand === void 0 ? void 0 : (_brand$inapp2 = brand.inapp) === null || _brand$inapp2 === void 0 ? void 0 : (_brand$inapp2$icons = _brand$inapp2.icons) === null || _brand$inapp2$icons === void 0 ? void 0 : _brand$inapp2$icons.message);
  var formattedTime = formatDate ? formatDate(created) : (0, _lib.getTimeAgo)(created);
  var prettyDate = (0, _lib.getPrettyDate)(created);
  var messageOptions = (0, _hooks.useMessageOptions)({
    read: read,
    labels: labels,
    messageId: messageId,
    readTrackingId: readTrackingId,
    unreadTrackingId: unreadTrackingId
  });

  var handleMarkAsReadOnClick = function handleMarkAsReadOnClick() {
    if (!read && messageId) {
      markMessageRead(messageId);
    }
  };

  (0, _hooks.useOnScreen)(ref, function () {
    if (!openTrackingId || opened || !messageId) {
      return;
    }

    markMessageOpened(messageId, openTrackingId);
  });
  return /*#__PURE__*/_react["default"].createElement(_styled.Container, {
    ref: ref,
    "data-testid": "inbox-message",
    className: (0, _classnames["default"])({
      read: read
    })
  }, !read && /*#__PURE__*/_react["default"].createElement(_styled.UnreadIndicator, null), renderedIcon, /*#__PURE__*/_react["default"].createElement(_styled.Contents, null, /*#__PURE__*/_react["default"].createElement(_styled.Title, null, title), blocks !== null && blocks !== void 0 && blocks.length ? blocks === null || blocks === void 0 ? void 0 : blocks.map(function (block, index) {
    if (block.type === "text") {
      if (renderBlocks !== null && renderBlocks !== void 0 && renderBlocks.text) {
        var Block = renderBlocks === null || renderBlocks === void 0 ? void 0 : renderBlocks.text;
        return /*#__PURE__*/_react["default"].createElement(Block, (0, _extends2["default"])({}, block, {
          key: index
        }));
      }

      return /*#__PURE__*/_react["default"].createElement(_styled.TextBlock, {
        key: index,
        "data-testid": "message-body"
      }, block.text && /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, block.text));
    }

    if (block.type === "action") {
      if (renderBlocks !== null && renderBlocks !== void 0 && renderBlocks.action) {
        var _Block = renderBlocks === null || renderBlocks === void 0 ? void 0 : renderBlocks.action;

        return /*#__PURE__*/_react["default"].createElement(_Block, (0, _extends2["default"])({}, block, {
          key: index
        }));
      }

      var actionProps = {
        onClick: handleMarkAsReadOnClick
      };
      var openInNewTab = typeof block.openInNewTab === "boolean" ? block.openInNewTab : openLinksInNewTab;

      if (openInNewTab) {
        actionProps = _objectSpread(_objectSpread({}, actionProps), {}, {
          target: "_blank",
          rel: "noreferrer"
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_styled.ActionBlock, {
        key: index
      }, /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
        href: block.url
      }, actionProps), block.text));
    }
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styled.TextBlock, null, body && /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, body)), (data === null || data === void 0 ? void 0 : data.clickAction) && /*#__PURE__*/_react["default"].createElement(_styled.ActionBlock, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: data === null || data === void 0 ? void 0 : data.clickAction,
    target: "_blank",
    rel: "noreferrer"
  }, "View Details")))), /*#__PURE__*/_react["default"].createElement(_styled.TimeAgo, {
    title: prettyDate
  }, formattedTime), messageOptions !== null && messageOptions !== void 0 && messageOptions.length ? /*#__PURE__*/_react["default"].createElement(_OptionsDropdown["default"], {
    options: messageOptions
  }) : undefined);
};

var _default = Message;
exports["default"] = _default;